
import { responseHero } from "../utils/axiosInterceptor";

export type DaisyEurRates = {

    ok: boolean;
    value: {
        refId: string;
        signer: {
            user_id: number;
            email: string;
            name: string;
        };
        signedTime: string;
        radioValue: string;
        yearCategory: string;
        diff: number;
        interestRate: number;
    };
}

export const getDaisyEurRates = (): Promise<DaisyEurRates[]> => {
    return new Promise<DaisyEurRates[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/daisyinterestlist`).then((response) => {
            resolve(response.data as DaisyEurRates[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};